export default __webpack_public_path__ + "static/media/rt_layout_submit.81a1e726.svg";